import React, { Component } from 'react';
import componentLookUp from '../../../shared/core/components.map';

type FsNotificationsPagePropsType = {
    components: string[]
}

type FsNotificationsPageState = {
    isLoaded: boolean,
    error: null,
    data: any
}

class FsNotificationsPage extends Component<FsNotificationsPagePropsType, FsNotificationsPageState> {
    render() {
        return(
            <>
                { this.props.components.map( (comp, index) => 
                    <div key={index}>{ componentLookUp(comp) }</div>
                )}
            </>
        )
    }
}

export default FsNotificationsPage;